export default __webpack_public_path__ + "static/media/help_blue.d084faa1.svg";